import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aee77cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "base-form" }
const _hoisted_6 = { style: {"text-align":"right"} }
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"right","line-height":"1rem","margin-top":"1rem","width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Opportunity = _resolveComponent("Opportunity")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.viewType == _ctx.ViewType.Creating)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новая модель автомобиля "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка модели автомобиля "),
                    (_ctx.originVehicleModel?.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.originVehicleModel.name), 1))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                ref: "f",
                rules: _ctx.rules,
                model: _ctx.form
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Модель",
                    "label-position": "top",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "Название модели автомобиля",
                        modelValue: _ctx.form.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                        max: "255"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Марка автомобиля",
                    "label-position": "top",
                    prop: "manufacturer"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        ref: "manufacturer",
                        auth: "",
                        modelValue: _ctx.form.manufacturer,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.manufacturer) = $event)),
                        "catalog-tab": _ctx.vehicleManufacturerCatalogTab,
                        placeholder: "Поиск марки автомобиля по названию",
                        "search-url": "/api/vehiclemanufacturers/search",
                        onCatalogItemPicked: _ctx.onVehicleManufacturerFromCatalog
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.manufacturer?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Описание",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.description,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
                        autosize: { minRows: 2, maxRows: 6 },
                        type: "textarea",
                        maxlength: "5000",
                        "show-word-limit": "",
                        placeholder: "Описание модели автомобиля"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _ctx.onFormSubmitClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Сохранить ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_el_button, {
                                type: "warning",
                                onClick: _ctx.onFormCancelClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.viewType == _ctx.ViewType.Editing ? 'Отменить изменения' : 'Очистить форму'), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          (_ctx.viewType == _ctx.ViewType.Editing)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                span: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: !_ctx.isViewLoaded && _ctx.isAsyncOperationPending || !_ctx.isVehicleModelDeletionAllowed,
                                      onClick: _ctx.onDeleteVehicleClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить автомобиль ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.viewType == _ctx.ViewType.Editing)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("   ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  (_ctx.isViewLoaded && !_ctx.isVehicleModelDeletionAllowed)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createVNode(_component_el_text, {
                                          type: "info",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Opportunity)
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" Нельзя удалить - модель автомобиля используется в автомобилях контрагентов ")
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model"])), [
                [_directive_loading, _ctx.isAsyncOperationPending]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}